import axios from "axios";
import { baseUrl } from "../config/clientsConfig";



const CallLogService = {

    getCallLogHistory: (docId, date) => {
      return axios.get(`${baseUrl}/analytics/callLog-History?docId=${docId}&startDate=${date}` );
    },
}
export default CallLogService;